import { useMutation } from '@tanstack/react-query';

import { type UpdateVoucherUsersExpiryByIdsPayload, updateVoucherUsersExpiryByIds } from '~/services/PromoService';

export function useUpdateVoucherUsersExpiryByIds() {
  return useMutation({
    mutationFn: (payload: UpdateVoucherUsersExpiryByIdsPayload) => updateVoucherUsersExpiryByIds(payload),
  });
}
